import {React,useEffect,useState,useContext} from 'react'
import axios from "axios";
import { GlobalLoading, showLoading } from 'react-global-loading';
import { MyContextProvider } from "../../../App";
import { API_URL, getAuthHeaders, getUserClaimsForUi } from '../../../Constant';
import {changeDateFormat, validateASIReportsRole} from "../../../Custom/Custom";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import messages from '../../../assets/Messages.json';
import {generateExcelASI} from '../../../Custom/ASIReport/PendencyReport/ExportaPendencyReportExcel'
import {generatePDF} from '../../../Custom/ASIReport/PendencyReport/ExportaPendencyReportPdf'
import asiTitle from '../../../asi.json';



function GetASIPendencyReport() {

  const currentDate = new Date();
  const prevMonthDate = new Date(currentDate);
  prevMonthDate.setMonth(currentDate.getMonth() - 1);
  const prevMonthName = prevMonthDate.toLocaleString('default', { month: 'short' }).toUpperCase();
  const [year,setyear]=useState([]);  
  const [yearName, setYearName] = useState('');

  
  const [surveyYear,setSurveyYear]=useState([]);
  const [surveyYearRang,setYearNameNext]=useState([]);
  const [yearNameNextTitle,setYearNameNextTitle]=useState([]);
  const [division,setdivision]=useState([]);
  const [divisionName,setdivisionName]=useState([]);
  const [district,setdistrict]=useState([]);
  const [districtName,setdistrictName]=useState([]);
  const [monthName,setMonthName]=useState(prevMonthName);
  const [divisionList,setDivisionList]=useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [selectedDivision, setSelectedDivision] = useState('');
  const [asiPendingDSLNOReport, setasiPendingDSLNOReport] = useState([]);


 

  const token=useContext(MyContextProvider).token;
  const navigate = useNavigate();

  const config = getAuthHeaders();

    const decoded = getUserClaimsForUi();
    const userLevel = decoded?.id?.USER_TYPE;
    const userlevelLogin = decoded?.id?.USER_LEVEL_LOCATION;
    const userlevelLoginName = decoded?.id?.LOCATION_NAME;
    const storedLanguage = localStorage.getItem('language');

useEffect(() => { //Get all Years Data


    const userRole = async () => {
      showLoading(true)
      try {
        const role = await validateASIReportsRole(decoded);
        if (!role) {
          alert("You are not an authorized for ASI Report");
          navigate("/dashboard");
        } 
      } catch (error) {
        console.log(error);
        showLoading(false)
      }
    }


    userRole();

   
         // All Division  list
      const fetchDivisionList = async () => {
        try {
           const response = await axios.get(`${API_URL}api/getalldivisionallist`, config);
           const allDivision = response.data;
  
          if (allDivision.status) {
            setDivisionList(allDivision.data);
            // showLoading(false);
          }
        } catch (error) {
          console.error(error);
          showLoading(false);
        }
      };

      fetchDivisionList();
      getSurveyYears();

      
      if (userLevel === "HEAD QUARTER") {
       getallDistrictList();
      }

}, []);



const getSurveyYears=async()=>{
  showLoading(true)
     try {
        const response = await axios.get(`${API_URL}api/asi/surveyYearList`, config);
        const allYear = response.data;
         if (allYear.status) {
            setyear(allYear.data.surveyYearList.reverse())
            showLoading(false);
        }
  } catch (error) {
     console.error(error);
     showLoading(false);
  }finally{
     showLoading(false);
  }

}


const getallDistrictList = async () => {
  try {
        const response = await axios.get(`${API_URL}api/getallDistrictList`, config);
        const allDistrictsHQ = response.data;
        setDistrictList(allDistrictsHQ.data); 
    } catch (error) {
        console.error(error);
    }
};






  const handleSubmit = async (event) => {
    event.preventDefault(); 

    
    if (!yearName) {
      toast.error('Please Select Survey Year', messages.COLOR_RED);
      return;
    }

    let modifiedDivision = division;
    let modifiedDistrict = district;


    if (Array.isArray(division) && division.length === 0) {
      modifiedDivision = "";
    }
    if (Array.isArray(district) && district.length === 0) {
      modifiedDistrict = "";
    }

    if(modifiedDivision === "00" || modifiedDistrict ==="00"){
      toast.info('Data not found.', messages.COLOR_RED);
      setasiPendingDSLNOReport([]);
      return false;
    }

    
    const post_data = {
      "survey_year": yearName,
      "division_code": modifiedDivision,
      "district_code": modifiedDistrict
    };
 

    try {

      showLoading(true);

      const response = await axios.post(`${API_URL}api/asi/reports/asiPendingDSLNOReport`, post_data, config);


      const pendencyData = response.data;

      if (pendencyData.status) {
        setasiPendingDSLNOReport(pendencyData.data);
        showLoading(false);
      }
    } catch (error) {
      console.error(error);
      showLoading(false);
    }


  };

  const handleYearChange = (event) => {
      setYearName(event.target.value);
      const selectedYear = parseInt(event.target.value);
      if (!isNaN(selectedYear)) {
        const nextYear = selectedYear + 1;
        setYearNameNext(`${selectedYear}_${nextYear}`);
        setYearNameNextTitle(`${selectedYear}-${nextYear}`);
      }
      
  };

  const handleDistrictChange = (event) => {
      setdistrict(event.target.value);
      const _selectedTextDis = event.target.options[event.target.selectedIndex].text;
      const _districtName = _selectedTextDis === "ALL" ? "" : _selectedTextDis;
      setdistrictName(_districtName);
  };
  
  const handleDivisionChange = async (event) => {
    const selectedDivision = event.target.value;
    setdivision(selectedDivision);

    if (userLevel !== "DIVISION LEVEL") {
      const _selectedText = event.target.options[event.target.selectedIndex].text;
      const _divisionName = _selectedText === "ALL" ? "" : _selectedText;
      setdivisionName(_divisionName);
    }
    
    if (selectedDivision) {
        // If division is selected, call the API immediately
        showLoading(true);
        const post_data = {
            division_Id: selectedDivision
        };
        try {
            const response = await axios.post(`${API_URL}api/geDistrictListByDivisionId`, post_data, config);
            const allDistricts = response.data;
            if (allDistricts.status) {
                setDistrictList(allDistricts.data);
                showLoading(false);
            }
        } catch (error) {
            console.error(error);
        }
    } else {
    
        setDistrictList([]);
    }
};

useEffect(() => {
    if (userLevel === "DIVISION LEVEL") {
        handleDivisionChange({ target: { value: userlevelLogin } });
        setdivisionName(userlevelLoginName);
    }
}, [division]);



// Date format: 19 February 2026 (DD Month YYYY)
const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const getDateWithMonthName = (date = new Date()) => {
  const d = new Date(date);
  const day = d.getDate();
  const month = monthNames[d.getMonth()];
  const year = d.getFullYear();
  return `${day} ${month} ${year}`;
};
const currentDateTimeShow = getDateWithMonthName();

//Generate Excel *************
const handleGenerateExcel = async () => {
  
  if (!yearName) {
    toast.error('Please Select Survey Year', messages.COLOR_RED);
    return;
  }

  if (!asiPendingDSLNOReport || !asiPendingDSLNOReport.results || !asiPendingDSLNOReport.results.length) {
    toast.error('First, search the data, then export as excel', messages.COLOR_RED);
    return;
  }

  let excelFileName=generateFileName("ASI_PendencyReport");
  const now = new Date();
  const downloadDateTime = `${getDateWithMonthName(now)} ${(now.getHours() % 12 || 12).toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')} ${now.getHours() < 12 ? 'AM' : 'PM'}`; // 19 February 2026 02:19 PM
  const excelObjectData = {
    fileName: excelFileName,
    reportType: excelFileName,
    fileType: 'xls',
    sheetName: excelFileName,
    firstRowMergeCells: "A1:K1",
    firstRowExportDate: `ASI, Uttar Pradesh (Pendency Report)`,
    firstRowCellNumber: 11,
    secondRowMergeCells: "A2:K2",
    secondRowText: `Survey Year: ${yearNameNextTitle}     ${downloadDateTime}`,
    secondRowExportDate: downloadDateTime,
    secondRowCellNumber: 11,
    headerEnglishColumns: [
      'Division Name', 'District Name','Allotted DSL', 'Pending', 'Pending DSL','Submitted', 'Submitted DSL', 'Accepted','Accepted DSL', 'Rejected','Rejected DSL'], headerHindiColumns: []
 };

 const transformedData = asiPendingDSLNOReport.results.map(item => [
    `${item.divisionName} (${item.divisionCode})`,
    `${item.districtName} (${item.districtCode})`,
    item.allottedDSL,
    item.pending,
    item.pendingDSL,
    item.submitted,
    item.submittedDSL,
    item.accepted,
    item.acceptedDSLlistdata,
    item.rejected,
    item.rejectedDSL
  ]);

  excelObjectData.excelRowData = transformedData;
  generateExcelASI(excelObjectData)


}

//Generate Pdf *************
const handleGeneratePdf=()=>{
  if (!yearName) {
    toast.error('Please Select Survey Year', messages.COLOR_RED);
    return;
  }

  if (!asiPendingDSLNOReport || !asiPendingDSLNOReport.results || !asiPendingDSLNOReport.results.length) {
    toast.error('First, search the data, then export as pdf', messages.COLOR_RED);
    return;
  }

    const heading1= "ASI, Uttar Pradesh";
    const heading2= "(Pendency Report)";
    const heading3= `Survey Year ${yearNameNextTitle}     ${currentDateTimeShow}`;
    const headerEnglishColumns= [
    'Division Name', 'District Name','Allotted DSL', 'Pending', 'Pending DSL',
    'Submitted', 'Submitted DSL', 'Accepted','Accepted DSL', 'Rejected','Rejected DSL'];
    const pdfData = asiPendingDSLNOReport.results.map(item => [
    `${item.divisionName} (${item.divisionCode})`,
    `${item.districtName} (${item.districtCode})`,
    item.allottedDSL?item.allottedDSL:0 ,
    item.pending?item.pending:'0',
    item.pendingDSL.length>0? `[${item.pendingDSL.join(", ")}]` :"[]",
    item.submitted?item.submitted:'0',
    item.submittedDSL.length>0? `[${item.submittedDSL.join(", ")}]`:"[]",
    item.accepted?item.accepted:'0',
    item.acceptedDSLlistdata?`[${item.acceptedDSLlistdata.join(", ")}]`: "[]",
    item.rejected?item.rejected:'0',
    item.rejectedDSL.length>0? `[${item.rejectedDSL.join(", ")}]` : "[]"
  ]);

  // const divisionName = pdfData.length > 0 ? pdfData[0][0] : 'UnknownDivision';
    // const districtName = pdfData.length > 0 ? pdfData[0][1] : 'UnknownDistrict';
    // const monthName = monthNameNextTitle || 'UnknownMonth';
    // const yearName = yearNameNextTitle || 'UnknownYear';

    // const PDFFileName = `ListReport_${divisionName}_${districtName}_${yearName}`;
    const PDFFileName= generateFileName("ASI_PendencyReport")
 
  const pdfObjectData = {
    heading1,
    heading2,
    heading3,
    headerEnglishColumns,
    pdfData,
    width:[100, 100, 150, 100, 180, 100, 160, 100, 160, 100, 160],
    PDFFileName
  };
 
   generatePDF(pdfObjectData)
}


//Create File name 
const generateFileName= (excelFileName)=>{

   if (typeof divisionName === "string" && divisionName !== "") {
    excelFileName = `${excelFileName}_${divisionName.replace(" ", "_")}`;
  }
  if (typeof districtName === "string" && districtName !=="") {
    excelFileName = `${excelFileName}_${districtName.replace(" ", "_")}`;
  }
  if (typeof yearName === "string" && yearName !=="") {
    excelFileName = `${excelFileName}_${surveyYearRang.replace(" ", "_")}`;
  }

  return excelFileName

}



  return (
    <>
    <ToastContainer />
    <GlobalLoading />

 <div className="container-fluid py-3">
     <div className="card mx-3 mb-3">
        <div className="card-body pb-1">
          <div className="row align-items-center">
           <h4 className="page_heading">
              <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.ASI_Pendency_Report : asiTitle.en.ASI_Pendency_Report }} />
            </h4>

           <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                <label>{storedLanguage === 'hi' ? asiTitle.hi.SERVEY_YEAR : asiTitle.en.SERVEY_YEAR}</label>
                <select value={yearName} onChange={handleYearChange} name="surveyYear"  className="form-select">
                  <option value="">Select Year</option>
                  {year
                      .sort((a, b) => b - a) 
                      .map((yearName, index) => (
                        <option key={index} value={yearName}>
                          {yearName}-{(parseInt(yearName) + 1).toString().slice(2)}
                        </option>
                  ))}
              </select>
            </div>

            {userLevel === "HEAD QUARTER" && (
              <>
                <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                <label>{storedLanguage === 'hi' ? asiTitle.hi.DIVISION : asiTitle.en.DIVISION}</label>
                
                <select value={division} onChange={handleDivisionChange} name="division" className="form-select">
                  <option value="">ALL</option>
                  { divisionList.length > 0 && divisionList.map((ele,i)=>(
                    <option key={ele.DIVISION_NAME} value={ele.DIVISION_CODE}>
                      {ele.DIVISION_NAME}
                    </option>
                  ))}
                </select>
                
            </div>
            
            <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                <label>{storedLanguage === 'hi' ? asiTitle.hi.DISTRICT : asiTitle.en.DISTRICT}</label>
                <select value={district} onChange={handleDistrictChange} name="district" className="form-select">
                  <option value="">ALL</option>
                  {districtList.map((ele, i) => (
                  <option key={ele.DISTRICT_CODE} value={ele.DISTRICT_CODE}>
                    {ele.DISTRICT_NAME}
                  </option>
                ))}
                </select>
            </div>
              </>
            )} 
            {userLevel === "DIVISION LEVEL" && (
              <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
              <label>{storedLanguage === 'hi' ? asiTitle.hi.DISTRICT : asiTitle.en.DISTRICT}</label>
              <select value={district} onChange={handleDistrictChange} name="district" className="form-select">
                <option value="">ALL</option>
                {districtList.map((ele, i) => (
                <option key={ele.DISTRICT_CODE} value={ele.DISTRICT_CODE}>
                  {ele.DISTRICT_NAME}
                </option>
              ))}
              </select>
            </div>
            )}

            
                  
          <div className="col-xl-2 col-lg-12 mb-3">
             <label className="w-100 d-none d-sm-block">&nbsp;</label>
             <button onClick={handleSubmit} type="submit" className="btn btn_orange">Search</button>
         </div>
         <div className="col-xl-4 col-lg-12 mb-3 text-end">
          <label className="w-100 d-none d-sm-block">&nbsp;</label>
              <Link to="#!" onClick={handleGenerateExcel} className="btn btn_green px-3 ms-auto">
                <img src="assets/images/excel.svg" alt="download Excel" className="me-2"/>Excel
                </Link>
               <Link to="#!" className="btn btn_green ms-1 px-3" onClick={handleGeneratePdf}>
                <img src="assets/images/pdf.svg" alt='download Pdf' className="me-2"/>PDF
              </Link>
         </div>
        </div>
      </div> 
     </div>
     {asiPendingDSLNOReport.results && asiPendingDSLNOReport.results.length > 0 && (
    <div className="card mx-3 mb-3">
        <div className="card-body">
            <div className="table-responsive">
                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th>Sr. No</th>
                            <th>Division Name</th>
                            <th>District Name</th>
                            <th>Allotted DSL</th>
                            <th>Pending</th>
                            <th>Pending DSL</th>
                            <th>Submitted</th>
                            <th>Submitted DSL</th>
                            <th>Accepted</th>
                            <th>Accepted DSL</th>
                            <th>Rejected</th>
                            <th>Rejected DSL</th>
                        </tr>
                    </thead>
                   
                    <tbody id="subTody">
                        {asiPendingDSLNOReport.results
                            .filter(item => {
                                for (const key in item) {
                                    if (item.hasOwnProperty(key)) {
                                        if (key === "pendingDSL" || key === "submittedDSL" || key === "acceptedDSLlistdata" || key === "rejectedDSL") {
                                            if (item[key] && Array.isArray(item[key])) {
                                                item[key] = item[key].map(value => parseInt(value));
                                            }
                                        }
                                    }
                                }
                                return item && (item.divisionName || item.districtName || item.allottedDSL || item.pending || item.pendingDSL || item.submitted || item.submittedDSL || item.accepted || item.acceptedDSLlistdata || item.rejected || item.rejectedDSL);
                            })
                            .map((item, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{item && item.divisionName ? `${item.divisionName} (${item.divisionCode})` : ""}</td>
                                    <td>{item && item.districtName ? `${item.districtName} (${item.districtCode})` : ""}</td>
                                    <td>{item && parseInt(item.allottedDSL) !== null ? parseInt(item.allottedDSL) : ""}</td>
                                    <td>{item && parseInt(item.pending) !== null ? parseInt(item.pending) : ""}</td>
                                    <td>{item && item.pendingDSL ? `[ ${item.pendingDSL.join(', ')} ]` : ""}</td>
                                    <td>{item && parseInt(item.submitted) !== null ? parseInt(item.submitted) : ""}</td>
                                    <td>{item && item.submittedDSL ? `[ ${item.submittedDSL.join(', ')} ]` : ""}</td>
                                    <td>{item && parseInt(item.accepted) !== null ? parseInt(item.accepted) : ""}</td>
                                    <td>{item && item.acceptedDSLlistdata ? `[ ${item.acceptedDSLlistdata.join(', ')} ]` : ""}</td>
                                    <td>{item && parseInt(item.rejected) !== null ? parseInt(item.rejected) : ""}</td>
                                    <td>{item && item.rejectedDSL ? `[ ${item.rejectedDSL.join(', ')} ]` : ""}</td>
                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>
        </div>
    </div>
)}
    
</div>
 
 </>
  )
}

export default GetASIPendencyReport